import React from "react";
import InputField from "../InputField";
import Dropdown from "../Dropdown";
import { format } from "date-fns";

const AddOnServiceForm = ({
  addOnService,
  setAddOnService,
  setHasChanges,
  billingGroups,
  onBillingGroupChange,
  disabledFields = [],
}) => {
  const selectedBillingGroup = addOnService?.billingGroupName || "";

  const isDisabled = (fieldName) => disabledFields.includes(fieldName);

  return (
    <>
      {/* Two-column layout */}
      <div className="grid grid-cols-2 gap-6 w-full">
        {/* Column 1 */}
        <div className="flex flex-col gap-4">
          <Dropdown
            label="Billing group"
            value={selectedBillingGroup}
            options={billingGroups.map((group) => group.name)}
            onSelect={(option) => {
              onBillingGroupChange(option);
              setHasChanges(true);
            }}
            disabled={isDisabled("billingGroupName")}
            />

          <InputField
            label="Comment"
            placeholder="Comment"
            value={addOnService?.comment || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, comment: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("comment")}
            />

          <InputField
            label="Created by"
            placeholder="Created by"
            value={addOnService?.createdBy || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, createdBy: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("createdBy")}
            />

          <InputField
            label="Created date"
            placeholder="Created date"
            value={
              addOnService?.createdDateTimeUTC
                ? format(new Date(addOnService.createdDateTimeUTC), "yyyy-MM-dd")
                : ""
            }
            onChange={(e) => {
              setAddOnService((s) => ({
                ...s,
                createdDateTimeUTC: e.target?.value,
              }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("createdDateTimeUTC")}
            />

          <InputField
            label="Name"
            placeholder="Name"
            value={addOnService?.name || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, name: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("name")}
            />
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4">
          <InputField
            label="Updated date"
            placeholder="Updated date"
            value={
              addOnService?.updatedDateTimeUTC
                ? format(new Date(addOnService.updatedDateTimeUTC), "yyyy-MM-dd")
                : ""
            }
            onChange={(e) => {
              setAddOnService((s) => ({
                ...s,
                updatedDateTimeUTC: e.target?.value,
              }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("updatedDateTimeUTC")}
            />

          <InputField
            label="Add-on service ID"
            placeholder="Add on service ID"
            value={addOnService?.addOnServicePublicId || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, addOnServicePublicId: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("addOnServicePublicId")}
            />

          <InputField
            label="Price"
            placeholder="Price"
            type="number"
            value={addOnService?.price || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, price: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("price")}
            />

          <InputField
            label="Updated by"
            placeholder="Updated by"
            value={addOnService?.updatedBy || ""}
            onChange={(e) => {
              setAddOnService((s) => ({ ...s, updatedBy: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("updatedBy")}
            />
        </div>
      </div>
    </>
  );
};

export default AddOnServiceForm;
